import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Avatar from '../Avatar';
import { getLastSeenNormalized } from '../../../Utils';
import CollaboratorShape from '../../PropsShape/CollaboratorShape';
import { sendMixPanelEvent } from '../../../Utils/mixpanel';
import { CLICKED_RESEND_COLLABORATOR, CLICKED_REMOVE_COLLABORATOR } from '../../../Utils/mixpanel/mixpanelEvents';
import { showErrorToast, showSuccessToast } from '../ButterToasts';
import * as Error from '../../utils/error';
import * as CollaboratorsActions from '../../actions/collaborators';
import * as CollaboratorsSelectors from '../../selectors/collaborators';
import * as GroupsSelectors from '../../selectors/groups';
import * as Translations from '../../providers/i18n';
import DeletePopup from './DeletePopup';

import './style.scss';

class Collaborator extends Component {
    constructor(props) {
        super(props);

        this.state = {
            deleting: false,
            shouldShowPopUp: false
        };

        this.delete = this.delete.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleResend = this.handleResend.bind(this);
        this.handleYesOnDeletePopup = this.handleYesOnDeletePopup.bind(this);
        this.handleNoOnDeletePopup = this.handleNoOnDeletePopup.bind(this);
    }

    delete() {
        this.setState({
            shouldShowPopUp: true
        });
    }

    handleDelete() {
        const {
            removeCollaborator,
            collaborator,
            i18n
        } = this.props;

        if (this.state.deleting) {
            removeCollaborator(collaborator.id)
                .catch((error) => {
                    Error.send(error, 'CollaboratorComponents');
                    showErrorToast(i18n.t('attachments_preview.collaboration.toasts.error'));
                });
        }
    }

    handleResend() {
        const {
            inviteCollaboratorsToCollaboratorsGroup,
            collaborator,
            currentCollaborator,
            i18n
        } = this.props;

        inviteCollaboratorsToCollaboratorsGroup({
            inviterFullName: currentCollaborator.fullName,
            emails: [collaborator.email]
        }).then(() => {
            showSuccessToast(i18n.t('attachments_preview.collaboration.toasts.invite_collaborators', { count: 1 }));
        }).catch((error) => {
            Error.send(error, 'CollaboratorComponents');
            showErrorToast(i18n.t('attachments_preview.collaboration.toasts.error'));
        });

        sendMixPanelEvent({
            eventName: CLICKED_RESEND_COLLABORATOR
        });
    }

    handleNoOnDeletePopup() {
        this.setState({
            shouldShowPopUp: false
        });
    }

    handleYesOnDeletePopup() {
        sendMixPanelEvent({
            eventName: CLICKED_REMOVE_COLLABORATOR
        });

        this.setState({
            deleting: true,
            shouldShowPopUp: false
        });
    }

    render() {
        const {
            i18n,
            collaborator
        } = this.props;

        const {
            lastSeen,
            email,
            userImage,
            username,
            removed
        } = collaborator;

        const { deleting, shouldShowPopUp } = this.state;

        if (removed) {
            return null;
        }

        const classes = classNames('collaborator-wrapper font-accent', {
            'delete-animation': deleting
        });

        if (!lastSeen) {
            return (
                <li className={classes} onAnimationEnd={this.handleDelete}>
                    <div className="collaborator-not-seen">
                        <p>{email}</p>
                        <div className="send-info">
                            <span>{i18n.t('attachments_preview.collaborators.invite_send')}</span>
                            <span className="separator"/>
                            <button onClick={this.handleResend}>{i18n.t('attachments_preview.collaborators.resend_invite')}</button>
                        </div>
                    </div>
                    <button className="delete" onClick={this.delete}>&times;</button>
                    {shouldShowPopUp && <DeletePopup handleYesOnDeletePopup={this.handleYesOnDeletePopup} handleNoOnDeletePopup={this.handleNoOnDeletePopup}/>}
                </li>
            );
        }

        const collaboratorName = username ? username : email;
        const lastSeenInMilliSeconds = lastSeen * 1000;
        const lastSeenFormated  = getLastSeenNormalized(lastSeenInMilliSeconds);

        return (
            <li className={classes} onAnimationEnd={this.handleDelete}>
                <div className="collaborator-seen">
                    <Avatar src={userImage} username={collaboratorName} size={36} className="collaborator-avatar"/>
                    <div className="collaborator-info">
                        <h4>{collaboratorName}</h4>
                        <div className="send-info">
                            {lastSeenFormated && <span>{i18n.t('attachments_preview.collaborators.last_seen_on')}{lastSeenFormated}</span>}
                            <span className="separator"/>
                            <button onClick={this.handleResend}>{i18n.t('attachments_preview.collaborators.resend_invite')}</button>
                        </div>
                    </div>
                </div>
                <button className="delete" onClick={this.delete}>&times;</button>
                {shouldShowPopUp && <DeletePopup handleYesOnDeletePopup={this.handleYesOnDeletePopup} handleNoOnDeletePopup={this.handleNoOnDeletePopup}/>}
            </li>
        );
    }

}

Collaborator.propTypes = {
    collaborator: CollaboratorShape.isRequired,
    currentCollaborator: CollaboratorShape.isRequired,
    inviteCollaboratorsToCollaboratorsGroup: PropTypes.func,
    removeCollaborator: PropTypes.func,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

Collaborator.defaultProps = {
    inviteCollaboratorsToCollaboratorsGroup: () => null,
    removeCollaborator: () => null
};

const mapStateToProps = (state, ownProps) => ({
    groupId: GroupsSelectors.getGroupIdByType(state, 'collaborators'),
    currentCollaborator: CollaboratorsSelectors.getCurrentCollaborator(state),
    collaborator: CollaboratorsSelectors.getCollaboratorById(state, ownProps.collaboratorId)
});

export default compose(
    Translations.connect,
    connect(mapStateToProps, {
        inviteCollaboratorsToCollaboratorsGroup: CollaboratorsActions.inviteCollaboratorsToCollaboratorsGroup,
        removeCollaborator: CollaboratorsActions.removeCollaborator
    }))(Collaborator);
